/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FinalizeInstructionGenerationDto,
  GenerateInstructionDto,
  InstructionGenerationOutputDto,
  InstructionListResponseDto,
  InvoiceUploadUrlRequestDto,
  RenameInstructionDto,
  UpdateInstructionFeedbackDto,
  UpdateInstructionVisibilityDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FinalizeInstructionGenerationDtoFromJSON,
    FinalizeInstructionGenerationDtoToJSON,
    GenerateInstructionDtoFromJSON,
    GenerateInstructionDtoToJSON,
    InstructionGenerationOutputDtoFromJSON,
    InstructionGenerationOutputDtoToJSON,
    InstructionListResponseDtoFromJSON,
    InstructionListResponseDtoToJSON,
    InvoiceUploadUrlRequestDtoFromJSON,
    InvoiceUploadUrlRequestDtoToJSON,
    RenameInstructionDtoFromJSON,
    RenameInstructionDtoToJSON,
    UpdateInstructionFeedbackDtoFromJSON,
    UpdateInstructionFeedbackDtoToJSON,
    UpdateInstructionVisibilityDtoFromJSON,
    UpdateInstructionVisibilityDtoToJSON,
} from '../models/index';

export interface DeleteInstructionRequest {
    instructionId: string;
}

export interface FinalizeGenerationRequest {
    finalizeInstructionGenerationDto: FinalizeInstructionGenerationDto;
}

export interface GenerateInstructionRequest {
    generateInstructionDto: GenerateInstructionDto;
}

export interface GetInstructionByPatientIdRequest {
    patientId: string;
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetInstructionByPatientIdDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetInstructionByPatientIdSortOrderEnum;
}

export interface GetInstructionGeneratedByProviderRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetInstructionGeneratedByProviderDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetInstructionGeneratedByProviderSortOrderEnum;
}

export interface GetInstructionGenerationOutputRequest {
    instructionId: string;
}

export interface GetInstructionsForPatientRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    dateRange?: GetInstructionsForPatientDateRangeEnum;
    customStartDate?: string;
    customEndDate?: string;
    sortBy?: string;
    sortOrder?: GetInstructionsForPatientSortOrderEnum;
}

export interface GetInvoiceUploadUrlRequest {
    invoiceUploadUrlRequestDto: InvoiceUploadUrlRequestDto;
}

export interface RenameInstructionRequest {
    instructionId: string;
    renameInstructionDto: RenameInstructionDto;
}

export interface UpdateInstructionFeedbackRequest {
    instructionId: string;
    updateInstructionFeedbackDto: UpdateInstructionFeedbackDto;
}

export interface UpdateInstructionVisibilityRequest {
    instructionId: string;
    updateInstructionVisibilityDto: UpdateInstructionVisibilityDto;
}

/**
 * 
 */
export class InstructionApi extends runtime.BaseAPI {

    /**
     * Deletes an instruction by ID. Only the provider who created it can delete it. The patient will no longer see this instruction.
     * Delete an instruction (Doctor only)
     */
    async deleteInstructionRaw(requestParameters: DeleteInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling deleteInstruction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/{instructionId}`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an instruction by ID. Only the provider who created it can delete it. The patient will no longer see this instruction.
     * Delete an instruction (Doctor only)
     */
    async deleteInstruction(requestParameters: DeleteInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInstructionRaw(requestParameters, initOverrides);
    }

    /**
     * Finalizes the instruction generation process by triggering the PDF generation process.
     * Finalize instruction generation
     */
    async finalizeGenerationRaw(requestParameters: FinalizeGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['finalizeInstructionGenerationDto'] == null) {
            throw new runtime.RequiredError(
                'finalizeInstructionGenerationDto',
                'Required parameter "finalizeInstructionGenerationDto" was null or undefined when calling finalizeGeneration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/finalize-generation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FinalizeInstructionGenerationDtoToJSON(requestParameters['finalizeInstructionGenerationDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finalizes the instruction generation process by triggering the PDF generation process.
     * Finalize instruction generation
     */
    async finalizeGeneration(requestParameters: FinalizeGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finalizeGenerationRaw(requestParameters, initOverrides);
    }

    /**
     * Generates an instruction for the authenticated doctor. Accepts either free text, invoice file, or both as input to feed into Gemini generation. No longer requires prescription.
     * Generate instruction (Doctor only)
     */
    async generateInstructionRaw(requestParameters: GenerateInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['generateInstructionDto'] == null) {
            throw new runtime.RequiredError(
                'generateInstructionDto',
                'Required parameter "generateInstructionDto" was null or undefined when calling generateInstruction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/generation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateInstructionDtoToJSON(requestParameters['generateInstructionDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates an instruction for the authenticated doctor. Accepts either free text, invoice file, or both as input to feed into Gemini generation. No longer requires prescription.
     * Generate instruction (Doctor only)
     */
    async generateInstruction(requestParameters: GenerateInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateInstructionRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves an instruction by its patient ID
     * Get instruction by patient ID
     */
    async getInstructionByPatientIdRaw(requestParameters: GetInstructionByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstructionListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getInstructionByPatientId().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getInstructionByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstructionListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves an instruction by its patient ID
     * Get instruction by patient ID
     */
    async getInstructionByPatientId(requestParameters: GetInstructionByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstructionListResponseDto> {
        const response = await this.getInstructionByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves an instruction generated by the authenticated provider
     * Get instruction generated by provider
     */
    async getInstructionGeneratedByProviderRaw(requestParameters: GetInstructionGeneratedByProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstructionListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getInstructionGeneratedByProvider().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/generated-by-provider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstructionListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves an instruction generated by the authenticated provider
     * Get instruction generated by provider
     */
    async getInstructionGeneratedByProvider(requestParameters: GetInstructionGeneratedByProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstructionListResponseDto> {
        const response = await this.getInstructionGeneratedByProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all files generated by Gemini for instruction generation, including the instruction file path, URL, and token usage
     * Get instruction generation output
     */
    async getInstructionGenerationOutputRaw(requestParameters: GetInstructionGenerationOutputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstructionGenerationOutputDto>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling getInstructionGenerationOutput().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/generation-output/{instructionId}`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstructionGenerationOutputDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all files generated by Gemini for instruction generation, including the instruction file path, URL, and token usage
     * Get instruction generation output
     */
    async getInstructionGenerationOutput(requestParameters: GetInstructionGenerationOutputRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstructionGenerationOutputDto> {
        const response = await this.getInstructionGenerationOutputRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the authenticated patient\'s own instructions. Patient only endpoint.
     * Get instructions for patient
     */
    async getInstructionsForPatientRaw(requestParameters: GetInstructionsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstructionListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getInstructionsForPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateRange'] != null) {
            queryParameters['dateRange'] = requestParameters['dateRange'];
        }

        if (requestParameters['customStartDate'] != null) {
            queryParameters['customStartDate'] = requestParameters['customStartDate'];
        }

        if (requestParameters['customEndDate'] != null) {
            queryParameters['customEndDate'] = requestParameters['customEndDate'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstructionListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the authenticated patient\'s own instructions. Patient only endpoint.
     * Get instructions for patient
     */
    async getInstructionsForPatient(requestParameters: GetInstructionsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstructionListResponseDto> {
        const response = await this.getInstructionsForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a signed URL for uploading invoice file directly to GCS. Frontend should upload the file to the signed URL, then use the returned GCS URI when calling generate instruction.
     * Get signed URL for invoice file upload
     */
    async getInvoiceUploadUrlRaw(requestParameters: GetInvoiceUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['invoiceUploadUrlRequestDto'] == null) {
            throw new runtime.RequiredError(
                'invoiceUploadUrlRequestDto',
                'Required parameter "invoiceUploadUrlRequestDto" was null or undefined when calling getInvoiceUploadUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/upload-url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvoiceUploadUrlRequestDtoToJSON(requestParameters['invoiceUploadUrlRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generates a signed URL for uploading invoice file directly to GCS. Frontend should upload the file to the signed URL, then use the returned GCS URI when calling generate instruction.
     * Get signed URL for invoice file upload
     */
    async getInvoiceUploadUrl(requestParameters: GetInvoiceUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getInvoiceUploadUrlRaw(requestParameters, initOverrides);
    }

    /**
     * Sets a custom display name for an instruction. The patient will see this name.
     * Rename an instruction
     */
    async renameInstructionRaw(requestParameters: RenameInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling renameInstruction().'
            );
        }

        if (requestParameters['renameInstructionDto'] == null) {
            throw new runtime.RequiredError(
                'renameInstructionDto',
                'Required parameter "renameInstructionDto" was null or undefined when calling renameInstruction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/{instructionId}/rename`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameInstructionDtoToJSON(requestParameters['renameInstructionDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a custom display name for an instruction. The patient will see this name.
     * Rename an instruction
     */
    async renameInstruction(requestParameters: RenameInstructionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameInstructionRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the feedback field for an instruction. Allowed for the instruction owner (patient) or the generating provider.
     * Update instruction feedback
     */
    async updateInstructionFeedbackRaw(requestParameters: UpdateInstructionFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstructionGenerationOutputDto>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling updateInstructionFeedback().'
            );
        }

        if (requestParameters['updateInstructionFeedbackDto'] == null) {
            throw new runtime.RequiredError(
                'updateInstructionFeedbackDto',
                'Required parameter "updateInstructionFeedbackDto" was null or undefined when calling updateInstructionFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/{instructionId}/feedback`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstructionFeedbackDtoToJSON(requestParameters['updateInstructionFeedbackDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstructionGenerationOutputDtoFromJSON(jsonValue));
    }

    /**
     * Updates the feedback field for an instruction. Allowed for the instruction owner (patient) or the generating provider.
     * Update instruction feedback
     */
    async updateInstructionFeedback(requestParameters: UpdateInstructionFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstructionGenerationOutputDto> {
        const response = await this.updateInstructionFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Hides or shows an instruction from the patient. Hidden instructions are not visible on the patient platform.
     * Toggle instruction visibility for patient
     */
    async updateInstructionVisibilityRaw(requestParameters: UpdateInstructionVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instructionId'] == null) {
            throw new runtime.RequiredError(
                'instructionId',
                'Required parameter "instructionId" was null or undefined when calling updateInstructionVisibility().'
            );
        }

        if (requestParameters['updateInstructionVisibilityDto'] == null) {
            throw new runtime.RequiredError(
                'updateInstructionVisibilityDto',
                'Required parameter "updateInstructionVisibilityDto" was null or undefined when calling updateInstructionVisibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/instruction/{instructionId}/visibility`.replace(`{${"instructionId"}}`, encodeURIComponent(String(requestParameters['instructionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstructionVisibilityDtoToJSON(requestParameters['updateInstructionVisibilityDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Hides or shows an instruction from the patient. Hidden instructions are not visible on the patient platform.
     * Toggle instruction visibility for patient
     */
    async updateInstructionVisibility(requestParameters: UpdateInstructionVisibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInstructionVisibilityRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetInstructionByPatientIdDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetInstructionByPatientIdDateRangeEnum = typeof GetInstructionByPatientIdDateRangeEnum[keyof typeof GetInstructionByPatientIdDateRangeEnum];
/**
 * @export
 */
export const GetInstructionByPatientIdSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetInstructionByPatientIdSortOrderEnum = typeof GetInstructionByPatientIdSortOrderEnum[keyof typeof GetInstructionByPatientIdSortOrderEnum];
/**
 * @export
 */
export const GetInstructionGeneratedByProviderDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetInstructionGeneratedByProviderDateRangeEnum = typeof GetInstructionGeneratedByProviderDateRangeEnum[keyof typeof GetInstructionGeneratedByProviderDateRangeEnum];
/**
 * @export
 */
export const GetInstructionGeneratedByProviderSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetInstructionGeneratedByProviderSortOrderEnum = typeof GetInstructionGeneratedByProviderSortOrderEnum[keyof typeof GetInstructionGeneratedByProviderSortOrderEnum];
/**
 * @export
 */
export const GetInstructionsForPatientDateRangeEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last3Months: 'last_3_months',
    Last6Months: 'last_6_months',
    Last12Months: 'last_12_months',
    CustomRange: 'custom_range'
} as const;
export type GetInstructionsForPatientDateRangeEnum = typeof GetInstructionsForPatientDateRangeEnum[keyof typeof GetInstructionsForPatientDateRangeEnum];
/**
 * @export
 */
export const GetInstructionsForPatientSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetInstructionsForPatientSortOrderEnum = typeof GetInstructionsForPatientSortOrderEnum[keyof typeof GetInstructionsForPatientSortOrderEnum];
